import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { OF_EN_COURS_DATA } from "../../models/data.model";
import { SharedModule } from "../../../../shared/shared.module";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";
import { Widget } from "../../models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { ArticlesInfosFacadeService } from "../../../articles/services/article-infos/article-infos-facade.service";
import { IconOfEtatComponent } from "../../../of/components/icon-of-etat/icon-of-etat.component";

@Component({
  selector: "vl-widget-of-en-cours",
  standalone: true,
  imports: [SharedModule, WidgetTitleComponent, IconOfEtatComponent],
  templateUrl: "./widget-of-en-cours.component.html",
  styleUrl: "./widget-of-en-cours.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetOfEnCoursComponent {
  data = input<OF_EN_COURS_DATA>();
  metadata = input<EntityMetadata>();
  widget = input<Widget>();
  articleInfosFacade = inject(ArticlesInfosFacadeService);

  ofs = computed(() => {
    return this.data()
      ?.data.sort((a, b) => a.ligne.localeCompare(b.ligne))
      .map((e) => {
        return {
          ...e,
          article: e.of.articleInfos,
        };
      });
  });

  constructor() {}
}
